import { render, staticRenderFns } from "./Shopify.vue?vue&type=template&id=445e5f58&"
import script from "./Shopify.vue?vue&type=script&lang=js&"
export * from "./Shopify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports